import {
  CaseCreatedByIcon,
  CaseCreationDateIcon,
  TotalFieldsIcon,
  TotalNotesIcon,
  TotalRemindersIcon,
  TotalUploadedFilesIcon,
} from "icons";
import { dateTimeFormatted, getFormattedDate } from "utils/helpers";

export function getData(data, utilityCount) {
  const { assignedTo, caseClosedDate, caseId, createdAt, createdBy, daysOpen } =
    data || {};

  return [
    {
      title: "Case Created by",
      icon: CaseCreatedByIcon,
      showInitials: true,
      width: "28%",
      key: "caseCreatedBy",
      details: [
        {
          title: "Name",
          value: createdBy?.name,
          key: "name",
        },
        {
          title: "Email",
          value: createdBy?.email,
          key: "email",
        },
        {
          title: "Creation Date",
          value: getFormattedDate(createdAt),
          key: "creationDate",
        },
        {
          title: "Creation Time",
          value: dateTimeFormatted(createdAt)?.split(" ")[1],
          key: "creationDate",
        },
        {
          title: "Case Open Since",
          value: daysOpen ? `${daysOpen} days` : 0,
          key: "caseOpenSince",
        },
      ],
    },
    {
      title: "Case Assigned To",
      icon: CaseCreatedByIcon,
      showInitials: true,
      width: "28%",
      key: "caseAssignedTo",
      details: [
        {
          title: "Name",
          value: assignedTo?.name,
          key: "name",
        },
        {
          title: "Email",
          value: assignedTo?.email,
          key: "email",
        },
      ],
    },

    {
      title: "Total Fields",
      icon: TotalFieldsIcon,
      width: "28%",
      key: "totalFields",
      details: [
        {
          title: "Fields Attempted",
          value: `${utilityCount?.validKeys} / 47`,
          key: "fieldsAttempted",
        },
        {
          title: "Attempts Recorded",
          value: `${utilityCount?.percentage} %`,
          key: "attemptsRecorded",
        },
      ],
    },
    {
      title: "Total Uploaded Files",
      icon: TotalUploadedFilesIcon,
      width: "28%",
      key: "totalUploadedFiles",
      details: [
        {
          title: "Files uploaded in case",
          value: utilityCount?.file,
          key: "filesUploadedInCase",
        },
      ],
    },
    {
      title: "Total Notes",
      icon: TotalNotesIcon,
      width: "20%",
      key: "totalNotes",
      details: [
        {
          title: "Total notes created",
          value: utilityCount?.notes,
          key: "totalNotesCreated",
        },
      ],
    },
    {
      title: "Total Reminders",
      icon: TotalRemindersIcon,
      width: "20%",
      key: "totalReminders",
      details: [
        {
          title: "Done",
          value: utilityCount?.reminders?.DONE,
          key: "done",
        },
        {
          title: "Pending",
          value: utilityCount?.reminders?.PENDING,
          key: "pending",
        },
      ],
    },
  ];
}
